
import { Component } from "vue-property-decorator";
import TemplateForm from "@/components/app/admin/notifications/templates/form.vue";

@Component
export default class TemplateFormModal extends TemplateForm {
  public render(h) {
    return h("validation-observer", { ref: "observer" }, [
      h(
        "modal-card",
        {
          props: {
            title: this.notificationTemplateId
              ? this.$t("_action.update_template")
              : this.$t("_action.create_template")
          },
          on: {
            close: () => this.$emit("close")
          },
          scopedSlots: {
            footer: () => {
              return h(
                "button",
                {
                  class: [
                    "button is-success",
                    { "is-loading": this.processing }
                  ],
                  attrs: {
                    disabled: this.processing
                  },
                  on: {
                    click: this.validateBeforeSubmit
                  }
                },
                [this.$t("_action.save")]
              );
            }
          }
        },
        [
          // Render parent template as child of this
          // @ts-ignore
          this.constructor.superOptions.render.call(this, h)
        ]
      )
    ]);
  }
}
